import React, { useState, Fragment, useEffect } from "react";
import TitleSection from "../../TitleSection/TitleSection";
import theme from "../../../App.module.sass";
import styles from "./CompanyData.module.sass";
import api from "../../../utils/api";
import formatters from "../../../utils/select-formatters";
import Input, { inputType } from "../../ui/Input/Input";
import masks from "../../../utils/masks";
import validation from "../../../utils/validation";

import currency from '../../../utils/currency'
import dateUtils from "../../../utils/date";

let didMount = false;

const setupOnChange = (setValues, values, ddds) => (value, name) => {
  if ((name === 'cellPhone' || name === 'phoneNumber') && value.length > 9) {
    const ddd = value.substr(0, 2);
    const dddInfo = ddds.find(el => el.ddd.slice(-2) === ddd);
    if (dddInfo) {
      setValues({
        ...values, [name + 'Details']: {
          number: value.substr(3),
          ddd: ddd,
          uf: dddInfo.uf,
          city: dddInfo.cidade
        },
        [name]: value
      });
      return;
    }
  }
  setValues({ ...values, [name]: value });
};

const getTooltip = condition => condition ? 'Quer alterar o faturamento? Fale com a gente no chat.' : null

const companyData = props => {
  const [values, setValues] = useState({
    socialName: "",
    cnpj: masks.cnpj(props.document),
    document: "",
    emitter: "",
    foundationDate: "",
    legalNature: "",
    activityType: "",
    capitalSocialValue: "",
    anualRevenues: currency.numberToCurrency(parseFloat(props.income)),
    cellPhone: "",
    phoneNumber: "",
    email: ""
  });

  let valuesBuffer;
  const cotista = props.data.origem.cotista;
  const person = props.data.pessoa;

  useEffect(() => {
    if(cotista) {
      const state = {
        socialName: person.dadosPessoaJuridica.nomeFantasia ,
        cnpj: masks.cnpj(props.document),
        document: person.dadosPessoaJuridica.documento.codigo,
        emitter: person.dadosPessoaJuridica.documento.orgaoEmissor,
        foundationDate: dateUtils.format(new Date(person.dadosPessoaJuridica.dataFundacao)),
        legalNature: person.dadosPessoaJuridica.ocupacao.valor,
        activityType: person.dadosPessoaJuridica.atividade.valor,
        capitalSocialValue: currency.numberToCurrency(parseInt(person.dadosPessoaJuridica.informacoesEconomicas.valorCapital)),
        anualRevenues: currency.numberToCurrency(parseInt(person.dadosPessoaJuridica.informacoesEconomicas.valorFaturamento)),
        cellPhone: "",
        phoneNumber: "",
        email: ""
      };

      setValues(state);
      valuesBuffer = state;
    }
  }, [props.data.pessoa]);

  const [ddds, setDDDs] = useState([]);
  const onChange = setupOnChange(setValues, values, ddds)
  useEffect(() => {
    if (!didMount) {
      api.get(api.endpoints.DDD).then((result) => {
        if (cotista) {
          const celular =
            props.data.pessoa.comunicacao.parametros.find(
              contact => contact.codigo === "celular");

          const fixo =
            props.data.pessoa.comunicacao.parametros.find(
              item => item.codigo === "telefone"
            );

          let ddd = celular.valor.substr(0, 2);
          let dddInfo = result.data.find(el => el.ddd.slice(-2) === ddd);
          if (dddInfo == null) {
            return;
          }
          const cellPhoneDetails = {
            number: celular.valor.substr(2),
            ddd: ddd,
            uf: dddInfo.uf,
            city: dddInfo.cidade
          };
          ddd = fixo.valor.substr(0, 2);
          dddInfo = result.data.find(el => el.ddd.slice(-2) === ddd);
          if (dddInfo == null) {
            return;
          }
          const phoneNumberDetails = {
            number: fixo.valor.substr(2),
            ddd: ddd,
            uf: dddInfo.uf,
            city: dddInfo.cidade
          };
          setValues({
            ...valuesBuffer,
            cellPhoneDetails,
            phoneNumberDetails
          });
        }
        setDDDs(result.data)
      });
      didMount = true;
    }

  });

  useEffect(() => {
    props.onChange(values);
  }, [values]);

  return (
    <Fragment>
      <section className={styles.sectionForm}>
        <TitleSection title="Dados da empresa" />

        <div className={styles.formGroup}>
          <div className={theme.row}>
            <Input
              className={theme.col60}
              name="socialName"
              value={values.socialName}
              onChange={onChange}
              type="text"
              typeDocument="Razão Social"
              readonly={cotista}
              validationRules={[validation.required, validation.minLength(3), validation.lettersOnly]}
              maxLength={30}
            />
            <Input
              className={theme.col40}
              name="cnpj"
              value={values.cnpj}
              onChange={onChange}
              type="text"
              typeDocument="CNPJ"
              mask={masks.mCNPJ}
              readonly
            />
          </div>
          <div className={theme.row}>
            <Input
              className={theme.col40}
              name="document"
              value={values.document}
              onChange={onChange}
              type="text"
              typeDocument="Documento"
              mask={masks.numberOnly}
              readonly={cotista}
              validationRules={[validation.required]}
              maxLength={30}
            />
            <Input
              className={theme.col20}
              name="emitter"
              value={values.emitter}
              onChange={onChange}
              type="text"
              typeDocument="Orgão emissor"
              readonly={cotista}
              validationRules={[validation.required]}
              maxLength={31}
            />
            <Input
              className={theme.col40}
              name="foundationDate"
              value={values.foundationDate}
              onChange={onChange}
              type="text"
              typeDocument="Data da fundação"
              mask={masks.date}
              readonly={cotista}
              validationRules={[validation.required, validation.date]}
              maxLength="10"
            />
          </div>
          <div className={theme.row}>
            <Input
              className={theme.col50}
              typeDocument="Natureza Jurídica"
              onSelect={value => {
                setValues({ ...values, legalNature: value });
              }}
              optionsUrl={api.endpoints.NATUREZA_JURIDICA}
              formatter={formatters.default}
              value={values.legalNature}
              type={inputType.AUTOCOMPLETE}
              readonly={cotista}
              validationRules={[validation.required]}
            />

            <Input
              className={theme.col50}
              typeDocument="Ramo da atividade"
              onSelect={value => {
                setValues({ ...values, activityType: value });
              }}
              optionsUrl={api.endpoints.RAMO_ATIVIDADE}
              formatter={formatters.default}
              value={values.activityType}
              type={inputType.AUTOCOMPLETE}
              readonly={cotista}
              validationRules={[validation.required]}
            />
          </div>
          <div className={theme.row}>
            <Input
              className={theme.col50}
              name="capitalSocialValue"
              value={values.capitalSocialValue}
              onChange={onChange}
              type="text"
              maxLength={18}
              typeDocument="Valor do capital Social"
              mask={masks.currency}
              readonly={cotista}
              validationRules={[validation.required, validation.greaterThan(0)]}
            />

            <Input
              className={theme.col50}
              name="anualRevenues"
              value={values.anualRevenues}
              onChange={onChange}
              type={inputType.currency}
              maxLength={18}
              typeDocument="Faturamento Médio"
              readonly
              tooltip={getTooltip(cotista)}
              validationRules={[validation.required]}
            />
          </div>
          <div className={theme.row}>
            <Input
              className={theme.col50}
              name="cellPhone"
              value={values.cellPhone}
              onChange={(value, name) => {value = value.substr(0, 11); onChange(value, name)}}
              type="text"
              typeDocument="Telefone Celular"
              mask={masks.phone}
              maxLength={15}
              validationRules={[validation.required, validation.phone('mobile'), validation.ddd(ddds)]}
            />
            <Input
              className={theme.col50}
              name="phoneNumber"
              value={values.phoneNumber}
              onChange={(value, name) => {value = value.substr(0, 11); onChange(value, name)}}
              type="text"
              typeDocument="Telefone Fixo"
              mask={masks.phone}
              maxLength={15}
              validationRules={[validation.phone('landline'), validation.ddd(ddds)]}
            />
          </div>
          <div className={theme.row}>
            <Input
              className={theme.col}
              name="email"
              value={values.email}
              onChange={onChange}
              type="text"
              typeDocument="E-mail"
              validationRules={[validation.required, validation.email]}
              maxLength={51}
            />
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default companyData;
